// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import type {AlertData, CSSDirectionType} from "./utils";

export type App = {|
    acceptedTerms: boolean,
    loadingSemaphore: number,
    riderLocation?: { lat: number, lng: number },
    alert?: AlertData,
    technicalIssue?: boolean,
    direction?: CSSDirectionType,
    isInIframe: boolean
|}

export const AppDefault: App = {
    acceptedTerms: false,
    loadingSemaphore: 0,
    isInIframe: window != window.top
};

const AppReducer = (app: App = AppDefault, action: Action): App => {
    const type = action.type;
    const payload = action.payload;
    switch (type) {
        case types.TERMS_BUTTON_CLICK:
            return {
                ...app,
                acceptedTerms: true,
            };
        case types.LOADING_SEMAPHORE_INCREMENT:
            return {
                ...app,
                loadingSemaphore: app[`loadingSemaphore`] + 1
            };
        case types.LOADING_SEMAPHORE_DECREMENT:
            return {
                ...app,
                loadingSemaphore: app[`loadingSemaphore`] - 1
            };
        case types.ALERT_DATA_SET:
            return {
                ...app,
                alert: payload,
            };
        case types.ALERT_DATA_CLEAR:
            return {
                ...app,
                alert: undefined,
            };
        case types.RIDER_LOCATION_UPDATE:
            return {
                ...app,
                riderLocation: payload,
            };
        case types.BLOCKING_TECHNICAL_ISSUE:
            return {
                ...app,
                technicalIssue: true,
            };
        case types.CSS_DIRECTION_SET:
            return {
                ...app,
                direction: payload,
            };


        default:
            return app;
    }
};

export default AppReducer;



// WEBPACK FOOTER //
// ./src/Store/Ducks/App/reducers.js